import { UI, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box, Pressable, IconButton } from 'native-base';
import React, { useState } from 'react';

export interface AccordionProps {
  title: string;
  content: React.ReactNode;
  initiallyOpen?: boolean;
  isMobile?: boolean;
}

export const ProductAccordion: React.FC<AccordionProps> = ({
  title,
  content,
  initiallyOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen);

  const handlePress = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box>
      <HStack justifyContent="space-between" alignItems="center">
        <Pressable onPress={handlePress}>
          <UI.Text variant="semibold" fontSize="md" color="brand.primary.darkest">
            {title.toUpperCase()}
          </UI.Text>
        </Pressable>
        <IconButton
          p={0}
          variant="unstyled"
          onPress={handlePress}
          icon={
            <UI.Icon
              name={isOpen ? 'ChevronUp' : 'ChevronDown'}
              size="xxs"
              color={Color['neutral.black']}
            />
          }
        />
      </HStack>
      {isOpen && <Box py={Spacing['stack.nano']}>{content}</Box>}
    </Box>
  );
};
